import { setupWorker } from 'msw';

import { mockHandlers } from './handlers';

// This configuration is for BROWSER
export const worker = setupWorker(...mockHandlers);

export const startMockWorker = () => {
  worker.start({ onUnhandledRequest: 'bypass' });
};
